import React from 'react';


import { connect } from 'react-redux';

import { v4 as uuid } from "uuid";

import { resolve, mapStateToProps } from "../smart/delegator/DataDelegator";
import Page from "../smart/Page";

class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            instanceIdentifier: uuid(),
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            if (this.props.show === true) {
                $(`#modal-confirmation-${this.state.instanceIdentifier}`).modal({ backdrop: 'static', keyboard: false });
            } else {
                $(`#modal-confirmation-${this.state.instanceIdentifier}`).modal('hide');
            }
        }
    }

    componentDidMount() {
        resolve(this.props, () => {
            if(this.props.show === true) {
                $(`#modal-confirmation-${this.state.instanceIdentifier}`).modal({ backdrop: 'static', keyboard: false });
            }
        });
    }

    onClose() {
        if (typeof this.props.onClose == "function") {
            this.props.onClose();
        } else if(this.props.onClose !== null && typeof this.props.onClose == "object") {
            if(this.props.onClose.type) {
                switch(this.props.onClose.type) {
                    case "redirect": {
                        if(this.props.onClose.redirect === true && this.props.onClose.redirect_url.length > 0) {
                            window.location = this.props.onClose.redirect_url;
                        }
                        break;
                    }

                    default: {
                        console.log(`Unknown onClose type ${this.props.onClose.type}`);
                        break;
                    }
                }
            }
        }

        $(`#modal-confirmation-${this.state.instanceIdentifier}`).modal('hide');
    }

    render() {
        const message = Array.isArray(this.props.message) ? this.props.message : [this.props.message];

        return (
            <div id={`modal-confirmation-${this.state.instanceIdentifier}`} className="modal fade" tabIndex="-1">
                <div className={`modal-dialog ${this.props.modalSize === "large" ? "modal-xl" : ""}`}>
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="text-center">
                                <p className="h4 pb-2 text-bold">{this.props.title}</p>
                                {Array.isArray(this.props.iconClasses) ?
                                    <h1 className="error-code">
                                        <i className={this.props.iconClasses.join(" ")}></i>
                                        <br />
                                    </h1>
                                    :
                                    null
                                }
                                
                                <div className="pad-btm">
                                    {message.map((m, index) => <div key={`confirmation_${index}_${m}`}>{m}</div>)}
                                </div>

                                {this.props.components !== undefined ? <Page robostackResolveData={this.props.components} /> : null}
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-start">
                            <button aria-label="No Button" onClick={() => typeof this.props.onNo == "function" ? this.props.onNo(this.onClose.bind(this)) : this.onClose()} type="button" className="btn btn-danger">
                                <i className="fas fa-times"></i>&nbsp;{this.props.noButtonText}
                            </button>

                            <button aria-label="Yes Button" onClick={() => typeof this.props.onYes == "function" ? this.props.onYes(this.onClose.bind(this)) : this.onClose()} type="button" className="btn btn-primary ml-auto">
                                <i className="fas fa-check"></i>&nbsp;{this.props.yesButtonText}
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(ConfirmationModal);